export default __webpack_public_path__ + "locales/lo-LA/About.json?hash=756e72c57d0ff37bb78bbd8f570676c5";